module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-sh.62c5b90b.png";